'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("./../authorisation"));

var _adminDashboard = _interopRequireDefault(require("./admin-dashboard"));

var _projectResponsibleDashboard = _interopRequireDefault(require("./project-responsible-dashboard"));

var _cantonResponsibleDashboard = _interopRequireDefault(require("./canton-responsible-dashboard"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var allProjects = ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh', 'lgw'];
var admin = (0, _authorisation.default)(['admin'], allProjects, false);
var projectresponsible = (0, _authorisation.default)(['projectresponsible'], allProjects, false);
var cantonresponsible = (0, _authorisation.default)(['cantonresponsible'], allProjects, false);
var AdminDashboard = admin(_adminDashboard.default);
var ProjectResponsibleDashboard = projectresponsible(_projectResponsibleDashboard.default);
var CantonResponsibleDashboard = cantonresponsible(_cantonResponsibleDashboard.default);

_es6Promise.default.polyfill();

var Dashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard(props) {
    _classCallCheck(this, Dashboard);

    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
  }

  _createClass(Dashboard, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-dashboard'
      }, /*#__PURE__*/_react.default.createElement("h1", null, t('welcome')), /*#__PURE__*/_react.default.createElement(AdminDashboard, this.props), /*#__PURE__*/_react.default.createElement(ProjectResponsibleDashboard, this.props), /*#__PURE__*/_react.default.createElement(CantonResponsibleDashboard, this.props));
    }
  }]);

  return Dashboard;
}(_react.default.Component);

Dashboard.propTypes = {
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(Dashboard);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard/index.js
// module id = 751
// module chunks = 0